// Must be first: captures ?code= / #error= before supabase-js scrubs them from
// the URL. See src/utils/oauthCallbackUrl.ts.
import "./utils/oauthCallbackUrl";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { QueryProvider } from "@/components/providers/QueryProvider";

// Initialize i18n before app renders
import "./i18n";

// Expose the cleanup script to the browser console, in development only. It is
// loaded on demand so that production builds, where it was never exposed, do
// not ship it in the entry chunk either.
if (import.meta.env.DEV) {
  void import("./scripts/cleanup-services").then(({ cleanupAllServices }) => {
    (window as any).cleanupAllServices = cleanupAllServices;
  });
}

const initializeTheme = () => {
  const persistedTheme = window.localStorage.getItem("moe-theme");

  // Default to light mode instead of OS preference if no theme is persisted
  const resolvedTheme =
    persistedTheme === "light" || persistedTheme === "dark"
      ? persistedTheme
      : "light";

  const root = document.documentElement;
  root.classList.toggle("dark", resolvedTheme === "dark");
  root.style.colorScheme = resolvedTheme;
  root.setAttribute("data-theme", resolvedTheme);
};

initializeTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </StrictMode>,
);
